export default __webpack_public_path__ + "static/media/c010-3.dfee0020.png";